import { useState } from "react";

import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import Popover from "@mui/material/Popover";
import { alpha } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { Link } from "react-router-dom";
import { FaSignOutAlt } from "react-icons/fa";

// ----------------------------------------------------------------------
const account = {
  displayName: "Jaydon Frankie",
  email: "demo@minimals.cc",
  photoURL: "/assets/images/avatars/avatar_25.jpg",
};

const MENU_OPTIONS = [
  {
    label: "Editar perfil",
    icon: "eva:home-fill",
    link: "/home/editar-perfil",
  },
  {
    label: "Reportes diarios",
    icon: "eva:person-fill",
    link: "/home/misReportesDiarios",
  },
  {
    label: "Mis estadísticas",
    icon: "eva:person-fill",
    link: "/home/estadisticas",
  },
];

// ----------------------------------------------------------------------

export default function AccountPopover({user,handleLogout}) {
  const [open, setOpen] = useState(null);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const logout=()=>{
    setOpen(null);
    handleLogout();
  }

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          width: 40,
          height: 40,
          background: (theme) => alpha(theme.palette.grey[500], 0.08),
          ...(open && {
            background: (theme) =>
              `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
          }),
        }}
      >
        <Avatar
          src={user.foto?.url ? user.foto.url : account.photoURL}
          alt={"Perfil"}
          sx={{
            width: 36,
            height: 36,
            border: (theme) => `solid 2px ${theme.palette.background.default}`,
          }}
        >
          {account.displayName.charAt(0).toUpperCase()}
        </Avatar>
      </IconButton>

      <Popover
        open={!!open}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 2,
            ml: 0.5,
            width: 240,
          },
        }}
      >
        <Box 
          sx={{ 
            px: 2, 
            py: 2,
            borderBottom: "solid", 
            borderBottomColor: "#f0f0f0",
            borderBottomWidth : 0.2 
          }}
        >
          <Typography  fontWeight={600} color={"MenuText"}  variant="subtitle2" noWrap>
             {user && user.name}
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
          {user && user.email}
          </Typography>
        </Box>

        {MENU_OPTIONS.map((option) => (
          <MenuItem key={option.label} onClick={handleClose}>
           <Link className="w-full" to={option.link}>
           <div className="w-full text-sm py-2"> {option.label}</div>
           </Link>
          </MenuItem>
        ))}

        <MenuItem
          disableRipple
          disableTouchRipple
          onClick={logout}
          type="button"
          sx={{
            typography: "body2",
            color: "error.main",
            py: 1.5,
            textAlign: "center",
            display: "flex",
            alignItems: "center",  
            justifyContent: "center",
            borderTop: "solid",
            borderTopColor: "#f0f0f0",
            borderTopWidth: 0.2,
          }}
        >
          <FaSignOutAlt style={{ marginRight: 8 }} /> {/* Icono con margen derecho */}
          Salir
        </MenuItem>
      </Popover>
    </>
  );
}
